// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"84":"cf0f167b","458":"5c644778","578":"cf793961"}[chunkId] + ".css";
};